import React from 'react'

function SecondSection() {
  return (
    <div className="flex justify-center items-center">
      <div className="mt-20 max-w-6xl mx-auto text-center px-4">
         <h1 className="text-3xl text-gray-600 md:text-5xl font-bold uppercase text-start text-yellow">
          Jadilah Bagian Dari Perjalanan Kami Menjadi Barbershop Terbaik Dan Terbesar Di Indonesia!
        </h1>
        <p className="text-xl text-gray-500 text-justify capitalize mt-14 mb-16">
          Papakilo Hairstudio adalah barbershop mewah terbesar di Indonesia, didirikan pada tahun 2022. 
          Dengan cabang di kota-kota besar seperti Jakarta dan Medan, kami terus berkembang untuk mencapai 130 lokasi pada tahun 2024.
        </p>
      </div>
    </div>
  )
}

export default SecondSection